import { ReactElement } from "react";

export type SubtitleProps = {
	text: string;
};

export const Subtitle = (props: SubtitleProps): ReactElement => (
	<h3>{props.text}</h3>
);
Subtitle.displayName = "ContentLayout.Subtitle";